import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "nonzero",
		d: "M9 15h2V9H9v6zm1-15C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM9 7h2V5H9v2z"
	})
});
export default SvgInfo;
